export enum DatadogErrorLevels {
  CRITICAL = 'critical',
  HIGH = 'high',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug',
  NOTSET = 'notset',
}
